module.exports = __webpack_public_path__ + "img/floor_OG3.ff0ac7aa.svg";